module.exports = __webpack_public_path__ + "黄俊琅-3f4b5480.png";